import { render, staticRenderFns } from "./background-fast.vue?vue&type=template&id=44ed428c&scoped=true"
import script from "./background-fast.vue?vue&type=script&lang=js"
export * from "./background-fast.vue?vue&type=script&lang=js"
import style0 from "./background-fast.vue?vue&type=style&index=0&id=44ed428c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ed428c",
  null
  
)

export default component.exports